import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import AutorenewOutlinedIcon from '@mui/icons-material/AutorenewOutlined';
import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined';

import CommonModal from '../../../../components/common-modal/CommonModal';
import CommonButton, { BUTTON_STYLES } from '../../../../components/common-button/CommonButton';
import GroupBadge from '../../connections/components/content-card/components/group-badge/GroupBadge';
import RatioBadge from '../../connections/components/content-card/components/ratio-badge/RatioBadge';
import MatchedThumbnail from './MatchedThumbnail';

import scss from './MatchedContentModal.module.scss';

function MatchedContentModal({
  isOpen,
  items = [],
  group,
  ratio,
  subtype,
  isApplying = false,
  isRegenerating = false,
  onClose,
  onUse,
  onRegenerate,
}) {
  const { t } = useTranslation('story');
  const [selectedId, setSelectedId] = useState(null);
  const isBusy = isApplying || isRegenerating;

  useEffect(() => {
    if (isOpen) {
      setSelectedId(null);
    }
  }, [isOpen]);

  const handleClose = () => {
    if (isBusy) return;

    onClose();
  };

  const handleUse = () => {
    if (!selectedId || isBusy) return;

    onUse(selectedId);
  };

  return (
    <CommonModal isOpen={isOpen} onClose={handleClose} isAnimated wrapperClassName={scss.modal}>
      <div className={scss.wrapper}>
        <div className={scss.header}>
          <h3 className={scss.title}>{t('matchedVersionsTitle')}</h3>
          <div className={scss.settings}>
            {group ? <GroupBadge group={group} /> : null}
            {ratio ? <RatioBadge ratio={ratio} /> : null}
          </div>
        </div>

        <div className={scss.grid}>
          {items.map((item) => (
            <MatchedThumbnail
              key={item.id}
              item={item}
              subtype={subtype}
              isSelected={selectedId === item.id}
              onSelect={setSelectedId}
              disabled={isBusy}
            />
          ))}
        </div>

        <div className={scss.actions}>
          <CommonButton
            styleColor={BUTTON_STYLES.SECONDARY}
            maxWidth={160}
            onClick={onRegenerate}
            disabled={isBusy}
            isLoading={isRegenerating}
            LeftIcon={<AutorenewOutlinedIcon />}>
            {t('regenerate')}
          </CommonButton>
          <CommonButton
            styleColor={BUTTON_STYLES.PRIMARY}
            maxWidth={220}
            onClick={handleUse}
            disabled={!selectedId || isBusy}
            isLoading={isApplying}
            LeftIcon={<CheckOutlinedIcon />}>
            {t('useThisVersion')}
          </CommonButton>
        </div>
      </div>
    </CommonModal>
  );
}

export default MatchedContentModal;
